<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_7382_16744)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM0 12C2.89694e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 -2.89694e-07 12 0C5.37258 2.89694e-07 -2.89694e-07 5.37258 0 12Z"
    />
    <path d="M11 18H13V10H11V18Z" />
    <path
      d="M12 8C12.5523 8 13 7.55229 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55229 11.4477 8 12 8Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_7382_16744">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>
